import React from "react";
import { DateSinglePicker } from "./DateSinglePicker";
import { toast } from "../@/components/ui/use-toast";

interface SingleDatePickerProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
  onStartDateSelect: (date: Date | undefined) => void;
  onEndDateSelect: (date: Date | undefined) => void;
}

const SingleDatePicker: React.FC<SingleDatePickerProps> = ({
  startDate,
  endDate,
  onStartDateSelect,
  onEndDateSelect,
}) => {
  const [dateError, setDateError] = React.useState<string | null>(null);

  const handleDateError = (message: string) => {
    toast({
      title: "Error Date Selection",
      description: message,
    });
  };

  const handleStartDateSelect = (date: Date | undefined) => {
    onStartDateSelect(date);
    if (endDate && date && endDate < date) {
      setDateError("End date can't be earlier than the start date.");
      handleDateError("End date can't be earlier than the start date.");
    } else {
      setDateError(null);
    }
  };

  const handleEndDateSelect = (date: Date | undefined) => {
    onEndDateSelect(date);
    if (date && startDate && date < startDate) {
      setDateError("End date cannot be earlier than the start date.");
      handleDateError("End date cannot be earlier than the start date.");
    } else {
      setDateError(null);
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row gap-2 w-full">
        <DateSinglePicker
          text="Start Date"
          onDateSelect={handleStartDateSelect}
          className={`w-full ${dateError ? "border-red-500" : ""}`}
        />
        <DateSinglePicker
          text="End Date"
          onDateSelect={handleEndDateSelect}
          className={`w-full ${dateError ? "border-red-500" : ""}`}
          startDate={startDate}
        />
      </div>
    </div>
  );
};

export default SingleDatePicker;
